import { render } from "./JsonTree.vue?vue&type=template&id=d2b15c0a&scoped=true"
import script from "./JsonTree.vue?vue&type=script&lang=js"
export * from "./JsonTree.vue?vue&type=script&lang=js"

import "./JsonTree.vue?vue&type=style&index=0&id=d2b15c0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b15c0a"]])

export default __exports__